import { Container } from 'react-bootstrap';
import { useState } from 'react';
import ManualBreadcrumb from '../../components/manual/ManualBreadcrumb';
import ManualAlert from '../../components/manual/ManualAlert';

function ManualGlossarioPage() {
  const [searchTerm, setSearchTerm] = useState('');

  const glossario = [
    {
      termo: 'Adolescente',
      definicao: 'Pessoa com idade entre 12 e 18 anos incompletos. No contexto do sistema, refere-se aos jovens em cumprimento de medida socioeducativa.',
      categoria: 'Geral'
    },
    {
      termo: 'Apreensão',
      definicao: 'Ato de retirar a liberdade do adolescente por suspeita de prática de ato infracional, podendo ser em flagrante ou por mandado judicial.',
      categoria: 'Jurídico'
    },
    {
      termo: 'Ato Infracional',
      definicao: 'Conduta descrita como crime ou contravenção penal praticada por criança ou adolescente.',
      categoria: 'Jurídico'
    },
    {
      termo: 'Atendimento',
      definicao: 'Registro de serviços prestados ao adolescente durante uma movimentação (psicológico, social, pedagógico, saúde, etc).',
      categoria: 'Sistema'
    },
    {
      termo: 'Alvará de Soltura',
      definicao: 'Documento judicial que determina a liberação imediata do adolescente.',
      categoria: 'Jurídico'
    },
    {
      termo: 'Dashboard',
      definicao: 'Painel de controle que exibe indicadores, estatísticas e gráficos do sistema em tempo real.',
      categoria: 'Sistema'
    },
    {
      termo: 'DPDF',
      definicao: 'Defensoria Pública do Distrito Federal. Órgão responsável pela defesa jurídica dos adolescentes.',
      categoria: 'Instituições'
    },
    {
      termo: 'ECA',
      definicao: 'Estatuto da Criança e do Adolescente (Lei 8.069/90). Legislação que rege os direitos e deveres de crianças e adolescentes no Brasil.',
      categoria: 'Jurídico'
    },
    {
      termo: 'Especialista',
      definicao: 'Profissional técnico que realiza atendimentos aos adolescentes (psicólogo, assistente social, pedagogo, profissional de saúde).',
      categoria: 'Geral'
    },
    {
      termo: 'Flagrante',
      definicao: 'Situação em que o adolescente é apreendido no momento da prática do ato infracional ou logo após.',
      categoria: 'Jurídico'
    },
    {
      termo: 'Internação',
      definicao: 'Medida socioeducativa privativa de liberdade aplicada em casos de atos infracionais graves.',
      categoria: 'Medidas'
    },
    {
      termo: 'Internação Provisória',
      definicao: 'Retenção temporária do adolescente, por até 45 dias, enquanto aguarda decisão judicial definitiva.',
      categoria: 'Medidas'
    },
    {
      termo: 'LDAP',
      definicao: 'Protocolo de autenticação de rede. No sistema, permite que servidores da SEJUS façam login usando credenciais da rede corporativa.',
      categoria: 'Sistema'
    },
    {
      termo: 'Liberdade Assistida',
      definicao: 'Medida socioeducativa em meio aberto onde o adolescente permanece em liberdade sob supervisão.',
      categoria: 'Medidas'
    },
    {
      termo: 'Maioridade Penal',
      definicao: 'Idade a partir da qual a pessoa responde penalmente como adulto (18 anos no Brasil).',
      categoria: 'Jurídico'
    },
    {
      termo: 'Mandado de Busca e Apreensão',
      definicao: 'Ordem judicial que autoriza a polícia a procurar e apreender um adolescente.',
      categoria: 'Jurídico'
    },
    {
      termo: 'Medida Socioeducativa',
      definicao: 'Sanção aplicada pelo juiz ao adolescente que praticou ato infracional, com caráter educativo e de responsabilização.',
      categoria: 'Medidas'
    },
    {
      termo: 'Meio de Entrada',
      definicao: 'Forma pela qual o adolescente deu entrada no sistema socioeducativo (flagrante, mandado, transferência, etc).',
      categoria: 'Sistema'
    },
    {
      termo: 'Meio de Saída',
      definicao: 'Forma pela qual o adolescente deixou a unidade socioeducativa (alvará, transferência, progressão, etc).',
      categoria: 'Sistema'
    },
    {
      termo: 'Movimentação',
      definicao: 'Registro da trajetória do adolescente no sistema, incluindo entrada, permanência e saída de unidades.',
      categoria: 'Sistema'
    },
    {
      termo: 'MPDFT',
      definicao: 'Ministério Público do Distrito Federal e Territórios. Órgão responsável pela acusação e fiscalização da aplicação das medidas.',
      categoria: 'Instituições'
    },
    {
      termo: 'Oitiva Informal',
      definicao: 'Procedimento em que o adolescente e seus responsáveis são ouvidos pelo Ministério Público antes da decisão sobre representação.',
      categoria: 'Jurídico'
    },
    {
      termo: 'Perfil de Usuário',
      definicao: 'Conjunto de permissões que define o que um usuário pode fazer no sistema (Admin, Técnico, MPDFT, DPDF, Especialista).',
      categoria: 'Sistema'
    },
    {
      termo: 'Progressão de Medida',
      definicao: 'Mudança para uma medida socioeducativa menos gravosa, como prêmio pelo bom comportamento e evolução do adolescente.',
      categoria: 'Medidas'
    },
    {
      termo: 'RBAC',
      definicao: 'Role-Based Access Control. Sistema de controle de acesso baseado em perfis e permissões.',
      categoria: 'Sistema'
    },
    {
      termo: 'Remissão',
      definicao: 'Perdão judicial que extingue ou suspende o processo socioeducativo, aplicável em casos menos graves.',
      categoria: 'Jurídico'
    },
    {
      termo: 'Representação',
      definicao: 'Peça oferecida pelo Ministério Público ao juiz, solicitando a aplicação de medida socioeducativa.',
      categoria: 'Jurídico'
    },
    {
      termo: 'SEJUS-DF',
      definicao: 'Secretaria de Estado de Justiça e Cidadania do Distrito Federal. Órgão responsável pela execução das medidas socioeducativas.',
      categoria: 'Instituições'
    },
    {
      termo: 'Semiliberdade',
      definicao: 'Medida socioeducativa restritiva de liberdade onde o adolescente dorme na unidade mas pode sair durante o dia para trabalhar ou estudar.',
      categoria: 'Medidas'
    },
    {
      termo: 'Situação',
      definicao: 'Status atual do adolescente no sistema (Internado, Liberado, Em Audiência, Transferido, etc).',
      categoria: 'Sistema'
    },
    {
      termo: 'SINASE',
      definicao: 'Sistema Nacional de Atendimento Socioeducativo. Conjunto de normas que regulamenta a execução das medidas socioeducativas no Brasil.',
      categoria: 'Jurídico'
    },
    {
      termo: 'Tabelas de Apoio',
      definicao: 'Cadastros auxiliares do sistema que alimentam listas e opções (unidades, situações, órgãos, especialistas, etc).',
      categoria: 'Sistema'
    },
    {
      termo: 'Transferência',
      definicao: 'Mudança do adolescente de uma unidade socioeducativa para outra.',
      categoria: 'Geral'
    },
    {
      termo: 'UAIP',
      definicao: 'Unidade de Atendimento Inicial e Passagem. Local onde adolescentes aguardam decisão judicial após apreensão (até 5 dias).',
      categoria: 'Unidades'
    },
    {
      termo: 'UNIP',
      definicao: 'Unidade de Internação Provisória. Local onde adolescentes aguardam julgamento em regime de internação provisória.',
      categoria: 'Unidades'
    },
    {
      termo: 'Unidade Socioeducativa',
      definicao: 'Estabelecimento físico onde adolescentes cumprem medidas socioeducativas (internação ou semiliberdade).',
      categoria: 'Unidades'
    },
    {
      termo: 'Vara da Infância e Juventude (VIJ)',
      definicao: 'Órgão do Poder Judiciário especializado em julgar casos envolvendo crianças e adolescentes.',
      categoria: 'Instituições'
    }
  ];

  const categorias = ['Todas', 'Geral', 'Jurídico', 'Medidas', 'Sistema', 'Instituições', 'Unidades'];
  const [categoriaFiltro, setCategoriaFiltro] = useState('Todas');

  const termosFiltrados = glossario.filter(item => {
    const matchSearch = item.termo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                       item.definicao.toLowerCase().includes(searchTerm.toLowerCase());
    const matchCategoria = categoriaFiltro === 'Todas' || item.categoria === categoriaFiltro;
    return matchSearch && matchCategoria;
  }).sort((a, b) => a.termo.localeCompare(b.termo));

  return (
    <Container fluid className="py-4">
      <ManualBreadcrumb 
        items={[
          { label: 'Manual', path: '/painel/manual' },
          { label: 'Glossário', path: '/painel/manual/glossario' }
        ]}
      />

      <div className="manual-header">
        <h1 className="manual-title">
          <i className="bi bi-book me-3"></i>
          Glossário de Termos
        </h1>
        <p className="manual-subtitle">
          Entenda os termos técnicos e jurídicos utilizados no sistema
        </p>
      </div>

      <ManualAlert type="info">
        Use a busca abaixo para encontrar rapidamente o significado de termos específicos. 
        Você também pode filtrar por categoria para ver apenas termos relacionados a um tema.
      </ManualAlert>

      {/* Busca e Filtros */}
      <div className="manual-intro-card mb-4">
        <div className="row g-3">
          <div className="col-md-8">
            <div className="input-group">
              <span className="input-group-text bg-dark border-secondary">
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                className="form-control bg-dark border-secondary text-light"
                placeholder="Digite um termo para buscar..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button 
                  className="btn btn-secondary" 
                  onClick={() => setSearchTerm('')}
                >
                  <i className="bi bi-x"></i>
                </button>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <select 
              className="form-select bg-dark border-secondary text-light"
              value={categoriaFiltro}
              onChange={(e) => setCategoriaFiltro(e.target.value)}
            >
              {categorias.map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>
        </div>
        
        {searchTerm && (
          <div className="mt-3 text-muted small">
            <i className="bi bi-info-circle me-2"></i>
            Encontrados {termosFiltrados.length} termo(s) para "{searchTerm}"
          </div>
        )}
      </div>

      {/* Lista de Termos */}
      <div className="row">
        {termosFiltrados.length > 0 ? (
          termosFiltrados.map((item, index) => (
            <div key={index} className="col-12 mb-3">
              <div className="manual-faq-item">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <h5 className="mb-0 text-success">
                    <i className="bi bi-check-circle me-2"></i>
                    {item.termo}
                  </h5>
                  <span className="badge bg-secondary">{item.categoria}</span>
                </div>
                <p className="mb-0 text-light">
                  {item.definicao}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12">
            <div className="manual-help-box text-center py-5">
              <i className="bi bi-search" style={{ fontSize: '3rem', opacity: 0.3 }}></i>
              <h5 className="mt-3 text-muted">Nenhum termo encontrado</h5>
              <p className="text-muted mb-0">
                Tente buscar com outras palavras ou altere o filtro de categoria
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Estatísticas */}
      <div className="manual-intro-card mt-4">
        <div className="row text-center">
          <div className="col-md-4">
            <div className="manual-help-box">
              <i className="bi bi-journal-text text-success" style={{ fontSize: '2rem' }}></i>
              <h4 className="mt-2 mb-0">{glossario.length}</h4>
              <p className="text-muted small mb-0">Termos cadastrados</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="manual-help-box">
              <i className="bi bi-tags text-primary" style={{ fontSize: '2rem' }}></i>
              <h4 className="mt-2 mb-0">{categorias.length - 1}</h4>
              <p className="text-muted small mb-0">Categorias</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="manual-help-box">
              <i className="bi bi-filter text-warning" style={{ fontSize: '2rem' }}></i>
              <h4 className="mt-2 mb-0">{termosFiltrados.length}</h4>
              <p className="text-muted small mb-0">Resultados da busca</p>
            </div>
          </div>
        </div>
      </div>

      <ManualAlert type="tip">
        <strong>Sugestão:</strong> Se você não encontrou um termo que esperava ver aqui, 
        entre em contato com o administrador do sistema para solicitarmos a inclusão.
      </ManualAlert>
    </Container>
  );
}

export default ManualGlossarioPage;
